
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.683","height":"25.336"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 145"}},[_c('g',{attrs:{"data-name":"Gruppe 144","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.3"}},[_c('g',{attrs:{"data-name":"Gruppe 142"}},[_c('path',{attrs:{"data-name":"Pfad 111","d":"M14.236.65v5.225h5.225z"}}),_c('g',{attrs:{"data-name":"Gruppe 141"}},[_c('path',{attrs:{"data-name":"Pfad 112","d":"M12.146 18.421H4.83a.005.005 0 010-.01h7.315a.005.005 0 010 .01z"}}),_c('path',{attrs:{"data-name":"Pfad 113","d":"M12.146 15.285H4.83a.005.005 0 010-.01h7.315a.005.005 0 010 .01z"}}),_c('path',{attrs:{"data-name":"Pfad 114","d":"M15.281 12.15H4.83a.005.005 0 010-.01h10.451a.005.005 0 010 .01z"}}),_c('path',{attrs:{"data-name":"Pfad 115","d":"M15.281 9.015H4.83a.005.005 0 010-.01h10.451a.005.005 0 010 .01z"}})]),_c('path',{attrs:{"data-name":"Pfad 116","d":"M14.889 18.782v-2.587l4.572-1.959v-8.36h-5.225V.65h-11.5a2.09 2.09 0 00-2.09 2.09v19.856a2.09 2.09 0 002.09 2.09h14.635a2.077 2.077 0 001.13-.336 6.1 6.1 0 01-3.612-5.568z"}})]),_c('g',{attrs:{"data-name":"Gruppe 143"}},[_c('path',{attrs:{"data-name":"Pfad 117","d":"M14.889 16.195v2.587a6.1 6.1 0 004.572 5.9 6.1 6.1 0 004.572-5.9v-2.587l-4.572-1.959z"}}),_c('path',{attrs:{"data-name":"Pfad 118","d":"M19.29 20.604l-.011-.011-1.385-1.389.022-.022 1.375 1.374 2.238-2.237.022.022z"}})])])])])
          )
        }
      }
    